<template>
  <sidenav orientation='vertical' :class='curClasses' style='border: none;'>
    <div v-if='fadeMenu' ref='fadeMenu' class='backgroundFade'></div>
    <!-- BOTÃO RECOLHER -->
    <div class='sidebar-header-container'>
      <button
        class='sidebar-collapse-button'
        @click='toggleSidenav'
        title='Recolher menu'
      >
        <i class='fas fa-chevron-left sidebar-collapse-icon'></i>
        <span>Recolher</span>
      </button>
    </div>
    <!-- MENU -->
    <div class='sidebar-menu-container'>
      <block-ui :loading='menuLoading'></block-ui>

      <div v-show='noMenuItems'>
        <sidenav-header style='color: white' class='font-weight-bold'>Nenhum menu disponível</sidenav-header>
      </div>

      <perfect-scrollbar
        ref='scrollDiv'
        :options='{ wheelPropagation: true, suppressScrollX: true }'
        class='sidebar-scroll-container'
        id='scrollDiv'
      >
        <div class='sidenav-inner'>
            <div
              v-for='(elem, index) in visibleMenuItems'
              :key="`menu-item-${index}-${elem.rota || elem.link || elem.title}`"
              class='w-100 sidenav-item-wrapper'
              :class="elem.destacado ? 'menu-destacado': 'menu-padrao'"
            >
              <div
                class='sidenav-item'
                v-if='elem.subitems === null'
                :class="{'active': isActive(null, elem.link, index)}"
                :id="'div-menu-'+elem.title.replace(/\s+/g,'-').toLowerCase()"
              >
                <a
                  :id="'menu-'+ elem.title.replace(/\s+/g,'-').toLowerCase()"
                  :href='elem.link'
                  @click.stop.prevent='onClick(elem)'
                  class='sidenav-link'
                  :class="{ 'menu-link-novo': elem.isNew }"
                >
                  <i class='sidenav-icon' :class='elem.icon'></i>
                  <div>
                    <span>{{elem.title}}</span>
                    <div v-if='elem.destacado'>{{elem.title.split(' ')[0]}}</div>
                  </div>
                  <b-badge
                    v-if="elem.title === 'Tarefas' && qtdTarefas > 0"
                    class='ml-auto'
                    variant='segfy'
                  >{{qtdTarefas}}</b-badge>
                  <b-badge
                    v-if="elem.link === '/financeiro/meusPagamentos' && financeiroBadge"
                    class='ml-1 badge-financeiro-vencimento'
                    :variant="financeiroBadge.level === 'Red' ? 'danger' : 'warning'"
                    :title="financeiroBadge.level === 'Red' ? 'Urgência: fatura próxima do vencimento ou vencida' : 'Atenção: fatura próxima do vencimento'"
                  >{{ financeiroBadgeLabel }}</b-badge>
                  <b-badge
                    v-if="elem.isNew"
                    class='ml-auto menu-new-badge'
                    variant='success'
                  >Novo</b-badge>
                </a>
              </div>

              <div
                class='sidenav-item group-item'
                v-else
                :class="{'active open': isActive(elem.rota, null, index, true)}"
                :name='elem.rota'
                :id="'div-menu-'+elem.title.replace(/\s+/g,'-').toLowerCase()"
                @mouseenter="onGroupHoverEnter($event, elem)"
                @mouseleave="onGroupHoverLeave"
              >
                <a
                  :id="'menu-'+ elem.title.replace(/\s+/g,'-').toLowerCase()"
                  href='javascript:void(0)'
                  @click='onParentMenuClick($event)'
                  class='sidenav-link sidenav-toggle'
                  :class="{ 'menu-link-novo': elem.isNew }"
                >
                  <i class='sidenav-icon' :class='elem.icon'></i>
                  <div>
                    <span>{{elem.title}}</span>
                  </div>
                  <b-badge
                    v-if="elem.isNew"
                    class='ml-auto menu-new-badge'
                    variant='success'
                  >Novo</b-badge>
                  <i class='fas fa-chevron-down sidenav-expand-icon'></i>
                </a>
                <div class='sidenav-menu d-flex'>
                  <div
                    class='sidenav-item'
                    v-for='(subitem, subIndex) in elem.subitems'
                    :key="`submenu-item-${index}-${subIndex}-${subitem.link || subitem.title}`"
                    :class="{'active': isActive(elem.rota, subitem.link, index)}"
                  >
                    <a
                      :id="'submenu-'+ subitem.title.replace(/\s+/g,'-').toLowerCase()"
                      :href='subitem.link'
                      @click.stop.prevent='onClick(subitem)'
                      class='sidenav-link'
                    >
                      <div>{{subitem.title}}</div>
                      <b-badge
                        v-if="subitem.isNew"
                        class='ml-auto menu-new-badge'
                        variant='success'
                      >Novo</b-badge>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </perfect-scrollbar>
      <ModalContratarMenu ref="modalContratarMenu"></ModalContratarMenu>      
    </div>
    <!-- /MENU -->

    <!-- BOTÃO SAIR -->
    <div class='sidebar-logout-container'>
      <button
        class='sidebar-logout-button'
        @click='handleLogout'
      >
        <i class='fas fa-sign-out-alt sidebar-logout-icon'></i>
        <span>Sair</span>
      </button>
    </div>
  </sidenav>  
</template>

<style lang='scss'>
@import '../../../style/common.scss';

// ── Design tokens ──────────────────────────────────────────────────────────
$sf-primary:        #FF5028;
$sf-primary-light:  rgba(255, 80, 40, 0.09);
$sf-primary-dark:   #e03f1a;
$sf-text-main:      #1e293b;
$sf-text-muted:     #64748b;
$sf-border:         #e8edf2;
$sf-radius:         8px;
$sf-transition:     200ms ease;

// ── Sidenav wrapper ────────────────────────────────────────────────────────
.sidenav.layout-sidenav {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 280px;
  flex-shrink: 0;
  box-sizing: border-box;
  background-color: #ffffff !important;
  border-right: 1px solid $sf-border;
}

.sidenav.layout-sidenav > .sidenav-header:first-child,
.sidenav.layout-sidenav > .sidenav-block:first-child {
  display: none !important;
}

.sidenav.layout-sidenav.bg-sidenav-theme {
  background-color: #ffffff !important;
}

// ── Logo areas ─────────────────────────────────────────────────────────────
.sidebar-logo-segfy {
  padding: 0.875rem 1rem;
  border-bottom: 1px solid $sf-border;
  flex-shrink: 0;
  box-sizing: border-box;
}

.sidebar-logo-container {
  height: 1.875rem;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.sidebar-logo-segfy-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.sidebar-logo-multify {
  padding: 0.25rem;
  flex-shrink: 0;
  box-sizing: border-box;
}

.sidebar-logo-multify-img {
  width: 100%;
  height: 3.75rem;
  object-fit: contain;
}

// ── Menu container ─────────────────────────────────────────────────────────
.sidebar-menu-container {
  flex-grow: 1;
  padding: 0.625rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
  box-sizing: border-box;
  position: relative;
}

.sidebar-scroll-container {
  flex: 1;
  height: 100%;
}

.sidenav-inner {
  padding: 0 !important;
  list-style: none;
  margin: 0;
  height: auto;
  display: block;
}

// ── Logout button ──────────────────────────────────────────────────────────
.sidebar-logout-container {
  padding: 0.625rem;
  border-top: 1px solid $sf-border;
  flex-shrink: 0;
  box-sizing: border-box;
}

.sidebar-logout-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.75rem 1rem;
  background: none;
  border: none;
  color: #e53e3e;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  text-transform: none;
  letter-spacing: 0.01em;
  border-radius: $sf-radius;
  box-sizing: border-box;
  transition: background-color $sf-transition, color $sf-transition;

  &:hover {
    background-color: rgba(229, 62, 62, 0.08);
    color: #c53030;
  }

  &:active {
    background-color: rgba(229, 62, 62, 0.14);
  }

  .sidebar-logout-icon {
    margin-right: 0.75rem;
    font-size: 1.125rem;
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  span {
    display: inline-block;
  }
}

// ── Scrollbar ──────────────────────────────────────────────────────────────
.sidebar-scroll-container {
  height: 100% !important;
  position: relative !important;
}

.sidebar-scroll-container > .ps {
  height: 100% !important;
  position: relative !important;
}

.sidebar-scroll-container .ps__rail-y {
  right: 0.25rem !important;
  z-index: 500;
}

.sidenav-inner.ps.ps--active-y > .ps__rail-y {
  z-index: 500;
  margin-right: 0px !important;
  right: 0.25rem !important;
}

// ── Item wrappers ──────────────────────────────────────────────────────────
.sidenav-item-wrapper {
  padding: 0;
  margin: 0;
  list-style: none;
}

.sidenav-item-wrapper .sidenav-item {
  padding: 0;
  margin: 0;
}

// ── Base link style ────────────────────────────────────────────────────────
.sidenav-item-wrapper .sidenav-item > .sidenav-link {
  padding: 0.4rem 0.75rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: $sf-text-main;
  font-size: 0.8125rem;
  font-weight: 500;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  border-radius: $sf-radius;
  transition: background-color $sf-transition, color $sf-transition;
  box-sizing: border-box;
  min-height: 38px;
  margin: 1px 0;
}

// Hover
.sidenav-item-wrapper > .sidenav-item > .sidenav-link:hover {
  background-color: #f6f7f9 !important;
  color: $sf-text-main !important;

  .sidenav-icon {
    color: $sf-primary !important;
  }
}

// Open/expanded parent
.sidenav-item-wrapper > .sidenav-item.open > .sidenav-link {
  background-color: #f6f7f9 !important;
  color: $sf-primary !important;

  .sidenav-icon {
    color: $sf-primary !important;
  }

  div > span {
    color: $sf-primary !important;
    font-weight: 600 !important;
  }
}

.sidenav-item-wrapper .sidenav-item.open:hover > .sidenav-link {
  background-color: #f6f7f9 !important;
}

// Active — fundo suave + borda fina + texto e ícone na cor da marca
.sidenav-item-wrapper > .sidenav-item.active > .sidenav-link {
  background-color: rgba(255, 80, 40, 0.06) !important;
  border: 1px solid rgba(255, 80, 40, 0.18);
  color: $sf-primary !important;
  padding-left: calc(0.75rem - 1px);

  .sidenav-icon {
    color: $sf-primary !important;
  }

  div > span {
    color: $sf-primary !important;
    font-weight: 600 !important;
  }
}

// ── Icon style ─────────────────────────────────────────────────────────────
.layout-sidenav .sidenav-link .sidenav-icon {
  font-size: 1rem;
  min-width: 32px;
  width: 32px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: $sf-text-muted;
  flex-shrink: 0;
  transition: color $sf-transition;
  margin-right: 0.125rem;
}

// ── Text div inside links ──────────────────────────────────────────────────
.sidenav .sidenav-item .sidenav-link > div {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0;
  margin: 0;

  > span {
    display: block;
    color: $sf-text-main;
    font-size: 0.8125rem;
    font-weight: 500;
    line-height: 1.5;
    transition: color $sf-transition;
  }
}

.sidenav .sidenav-item.active > .sidenav-link > div > span {
  font-weight: 600;
  color: $sf-primary;
}

.sidenav.layout-sidenav .menu-padrao {
  border-top: none;
}

// ── Submenu ────────────────────────────────────────────────────────────────
.sidenav-menu {
  padding: 2px 0 4px 0;
  margin: 0;
  list-style: none;
}

.sidenav-menu .sidenav-item {
  padding: 0;
}

.sidenav-menu .sidenav-link {
  padding-left: 3.5rem !important;
  padding-right: 0.75rem;
  padding-top: 0.3rem !important;
  padding-bottom: 0.3rem !important;
  min-height: 34px;
  border-radius: $sf-radius;
  margin: 1px 0;
}

.sidenav-menu .sidenav-link .sidenav-icon {
  min-width: 28px !important;
  width: 28px !important;
  height: 28px;
  font-size: 0.875rem;
}

.sidenav-menu .sidenav-link > div {
  font-size: 0.7875rem !important;
  font-weight: 450;
  color: #475569;

  > span {
    font-size: 0.7875rem !important;
    color: #475569;
  }
}

.sidenav-menu .sidenav-item > .sidenav-link:hover {
  background-color: #f6f7f9 !important;

  > div {
    color: $sf-primary !important;
    > span { color: $sf-primary !important; }
  }
}

.sidenav-menu .sidenav-item.active > .sidenav-link {
  background-color: rgba(255, 80, 40, 0.06) !important;
  border: 1px solid rgba(255, 80, 40, 0.18);
  padding-left: calc(3.5rem - 1px) !important;

  > div {
    color: $sf-primary !important;
    font-weight: 600 !important;

    > span {
      color: $sf-primary !important;
      font-weight: 600 !important;
    }
  }
}

// ── Chevron toggle ─────────────────────────────────────────────────────────
.sidenav-toggle::after {
  display: none !important;
  content: none !important;
}

.sidenav-expand-icon {
  margin-left: auto;
  font-size: 11px;
  color: $sf-text-muted;
  transition: transform 250ms ease, color $sf-transition;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  margin-right: 0.25rem;
  flex-shrink: 0;
}

.sidenav-item.open > .sidenav-link .sidenav-expand-icon {
  transform: rotate(180deg);
  color: $sf-primary;
}

.sidenav-toggle .menu-new-badge + .sidenav-expand-icon {
  margin-left: 0.25rem;
}

// ── Text overflow ──────────────────────────────────────────────────────────
.sidenav.layout-sidenav .sidenav-link > div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidenav.layout-sidenav .sidenav-link > div > div {
  opacity: 0;
  position: absolute;
  bottom: 1px;
  left: 0px;
  width: 74px;
  font-size: 10px;
  text-align: center;
}

// ── Accordion animation ────────────────────────────────────────────────────
.sidenav-item .sidenav-menu {
  max-height: 0px;
  overflow: hidden !important;
  padding: 0px;

  -webkit-transition: max-height 0.25s ease-in-out !important;
  -moz-transition: max-height 0.25s ease-in-out !important;
  -o-transition: max-height 0.25s ease-in-out !important;
  transition: max-height 0.25s ease-in-out !important;
}
.sidenav-item.open .sidenav-menu {
  max-height: 500px;
}

// ── New badge ──────────────────────────────────────────────────────────────
.menu-new-badge {
  font-size: 0.5625rem !important;
  padding: 0.125rem 0.4rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.06em !important;
  background-color: #10b981 !important;
  border: none !important;
  color: white !important;
  border-radius: 20px !important;
  height: 18px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;
  white-space: nowrap !important;
  box-sizing: border-box !important;
  margin-left: 0.5rem !important;
}

.sidenav-toggle .menu-new-badge {
  margin-right: 0.25rem !important;
}

// ── Header + botão recolher ────────────────────────────────────────────────
.sidebar-header-container {
  padding: 0.5rem 0.625rem 0.375rem;
  border-bottom: 1px solid $sf-border;
  flex-shrink: 0;
  box-sizing: border-box;
}

.sidebar-collapse-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.6rem 1rem;
  margin-bottom: 0.25rem;
  background: none;
  border: none;
  color: $sf-text-muted;
  cursor: pointer;
  font-size: 0.8125rem;
  font-weight: 500;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  border-radius: $sf-radius;
  box-sizing: border-box;
  transition: background-color $sf-transition, color $sf-transition;

  &:hover {
    background-color: #f6f7f9;
    color: $sf-text-main;
  }

  .sidebar-collapse-icon {
    font-size: 0.75rem;
    margin-right: 0.75rem;
    flex-shrink: 0;
    transition: transform 300ms ease;
  }

  span {
    display: inline-block;
  }
}

// ── Flyout submenu (modo colapsado) ────────────────────────────────────────
.sidebar-flyout {
  position: fixed;
  z-index: 9999;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.10), 0 2px 8px rgba(0, 0, 0, 0.05);
  min-width: 200px;
  padding: 0.375rem;
  pointer-events: all;

  // Setinha apontando para o ícone
  &::before {
    content: '';
    position: absolute;
    left: -5px;
    top: 1.125rem;
    width: 10px;
    height: 10px;
    background: #ffffff;
    border-left: 1px solid rgba(0, 0, 0, 0.08);
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    transform: rotate(45deg);
  }
}

.sidebar-flyout-header {
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #94a3b8;
  padding: 0.375rem 0.625rem 0.4rem;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 0.25rem;
  white-space: nowrap;
}

.sidebar-flyout-item {
  display: flex;
  align-items: center;
  padding: 0.45rem 0.625rem;
  font-size: 0.8rem;
  font-weight: 450;
  color: #475569;
  border-radius: 7px;
  cursor: pointer;
  white-space: nowrap;
  min-height: 34px;
  transition: background-color 150ms ease, color 150ms ease;

  &:hover {
    background-color: #f6f7f9;
    color: $sf-primary;
  }

  &.active {
    background-color: rgba(255, 80, 40, 0.06);
    border: 1px solid rgba(255, 80, 40, 0.18);
    color: $sf-primary;
    font-weight: 600;
    padding: calc(0.45rem - 1px) calc(0.625rem - 1px);
  }
}

// Animação de entrada do flyout
.sf-flyout-enter-active {
  transition: opacity 150ms ease, transform 150ms ease;
}
.sf-flyout-leave-active {
  transition: opacity 100ms ease, transform 100ms ease;
}
.sf-flyout-enter, .sf-flyout-leave-to {
  opacity: 0;
  transform: translateX(-6px);
}

// ── Collapsed sidebar ──────────────────────────────────────────────────────
@media (min-width: 1199px) {
  .layout-collapsed .layout-sidenav {
    width: 4.25rem !important;
    margin-right: 0 !important;
    -webkit-transform: none !important;
    transform: none !important;
  }

  // Centraliza cada link e remove borda/bg padrão
  .layout-collapsed .layout-sidenav .sidenav-item-wrapper .sidenav-item > .sidenav-link {
    padding: 0.4rem !important;
    justify-content: center !important;
    border: none !important;
    background-color: transparent !important;
    box-shadow: none !important;
  }

  // Mantém destaque no item ativo
  .layout-collapsed .layout-sidenav .sidenav-item-wrapper > .sidenav-item.active > .sidenav-link {
    background-color: rgba(255, 80, 40, 0.06) !important;
    border: 1px solid rgba(255, 80, 40, 0.18) !important;
    padding: calc(0.4rem - 1px) !important;
  }

  // Remove margem do ícone para centralizar
  .layout-collapsed .layout-sidenav .sidenav-link .sidenav-icon {
    margin-right: 0 !important;
  }

  // Esconde: texto, chevron, submenus abertos e badges
  .layout-collapsed .layout-sidenav .sidenav-link > div,
  .layout-collapsed .layout-sidenav .sidenav-expand-icon,
  .layout-collapsed .layout-sidenav .sidenav-item .sidenav-menu,
  .layout-collapsed .layout-sidenav .menu-new-badge {
    display: none !important;
  }

  // Sem a badge "Novo", o item novo ganha um ponto no ícone
  .layout-collapsed .layout-sidenav .sidenav-link.menu-link-novo .sidenav-icon {
    position: relative;
  }

  .layout-collapsed .layout-sidenav .sidenav-link.menu-link-novo .sidenav-icon::after {
    content: '';
    position: absolute;
    top: -3px;
    right: 3px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #10b981;
    box-shadow: 0 0 0 2px #ffffff;
  }

  // Botão recolher: centraliza ícone, inverte chevron, esconde texto
  .layout-collapsed .layout-sidenav .sidebar-header-container {
    padding: 0.5rem 0.25rem 0.375rem;
  }

  .layout-collapsed .layout-sidenav .sidebar-collapse-button {
    padding: 0.6rem !important;
    justify-content: center;

    span { display: none; }

    .sidebar-collapse-icon {
      margin-right: 0;
      transform: rotate(180deg);
    }
  }

  // Botão sair: centraliza ícone, esconde texto
  .layout-collapsed .layout-sidenav .sidebar-logout-button {
    padding: 0.6rem !important;
    justify-content: center;

    .sidebar-logout-icon { margin-right: 0; }

    span { display: none; }
  }
}
</style>

<script>
import {
  Sidenav,
  SidenavLink,
  SidenavRouterLink,
  SidenavMenu,
  SidenavHeader,
  SidenavBlock,
  SidenavDivider
} from '@/vendor/libs/sidenav'

import BlockUI from '../../../components/common/blockUI'
import PerfectScrollbar from '@/vendor/libs/perfect-scrollbar/PerfectScrollbar'
import {
  getMenu,
  marcarModuloVisto,
  getRestricaoHorarioAtiva
} from '../../../components/notificacao/methods.js'
import { logoffUser } from '../../../components/auth/methods.js'
import { getTarefas } from '../../../components/tarefas/methods.js'
import { fetchMeusPagamentosBadge } from '../../../components/financeiro/meusPagamentosBadgeApi.js'
import {
  APRESENTACOES,
  consultarApresentacao,
  ehDispensaDaApresentacao
} from '../../../components/common/apresentacaoProduto.js'
import 'driver.js/dist/driver.min.css'
import { mapState, mapActions } from 'vuex'
import Cookies from 'js-cookie'
import ModalContratarMenu from '../../../components/common/modalContratarMenu'
import { ehAvisoDeModulosAlterados } from '../../../components/common/mensagensLoja.js'

// Produtos SaaS que abrem em ABA NOVA: link do item de menu (vem da auth) -> página
// de passagem do SSO no app novo. Acrescentar produto aqui é uma linha; a rota com o
// iframe continua existindo como fallback de popup bloqueado. Produto com tela de
// apresentação (APRESENTACOES) só abre direto depois que o usuário a dispensou; antes
// disso o clique vai para a rota, que mostra a LP dentro do Gestão.
const LAUNCHERS_SAAS = {
  '/inteligencia': '/Inteligencia/Abrir',
  '/seguranca': '/Seguranca/Abrir',
  '/mensagem': '/Mensagem/Abrir'
}

export default {
  name: 'app-layout-sidenav',
  components: {
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider,
    'block-ui': BlockUI,
    PerfectScrollbar,
    ModalContratarMenu
  },

  data: function () {
    return {
      sideMenuItems: [],
      noMenuItems: false,
      menuLoading: false,
      qtdTarefas: 0,
      financeiroBadge: null,
      financeiroBadgeIntervalId: null,
      // chave do módulo -> true quando o usuário dispensou a tela de apresentação
      apresentacoesDispensadas: {},
      ultimaChecagemRestricao: new Date(),
      novaAssinatura:
        new Date(this.$store.state.auth.dataAssinatura) >=
        new Date('2019-09-27'),
      flyoutLeaveTimer: null,
      recargaMenuTimer: null
    }
  },
  created () {
    this.menuLoading = true
    this.requestMenuItems()

    this.usuarioLiberadoCotarSaude = this.$store.state.auth.acessoCotacaoSaude
  },

  mounted: function () {
    window.addEventListener('message', this.onMensagemLoja)
    let val = this.stepOnboarding
    this.actionsByStep(val)
    this.$root.$on('sidenav-flyout-item-click', this.onClick)
    window.addEventListener('message', this.onMensagemApresentacao)
  },

  beforeDestroy () {
    window.removeEventListener('message', this.onMensagemLoja)
    clearTimeout(this.recargaMenuTimer)
    this.$root.$off('sidenav-flyout-item-click', this.onClick)
    window.removeEventListener('message', this.onMensagemApresentacao)
  },
  watch: {
    stepOnboarding: function (val) {
      this.actionsByStep(val)
    },
    '$route.path' () {
      this.refreshFinanceiroBadge()
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (
        bg.indexOf(' sidenav-dark') !== -1 ||
        bg.indexOf(' sidenav-light') !== -1
      ) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + 'layout-sidenav'
    },
    currentPath () {
      return this.$route.path.toLowerCase()
    },
    visibleMenuItems () {
      if (this.$store.state.auth.isMeusPagamentosRestrito) {
        return this.sideMenuItems.filter(item =>
          item.link === '/financeiro/meusPagamentos' ||
          (item.subitems && item.subitems.some(s => s.link === '/financeiro/meusPagamentos'))
        )
      }
      if (!this.$store.state.auth.acessoMeuPlanoSegfy) {
        return this.sideMenuItems.filter(item =>
          item.link !== '/financeiro/meusPagamentos' &&
          !(item.subitems && item.subitems.every(s => s.link === '/financeiro/meusPagamentos'))
        )
      }
      return this.sideMenuItems
    },
    financeiroBadgeLabel () {
      if (!this.financeiroBadge) return ''
      const d = this.financeiroBadge.days
      if (d === null || d === undefined) return '!'
      return String(d)
    },
    ...mapState('newOnboarding', {
      stepOnboarding: 'step',
      fadeMenu: 'fadeMenu'
    })
  },

  methods: {
    actionsByStep (val) {
      if (val === 3) {
        this.unlockMenu('all')
        let element = document.getElementById('menu-configurações')
        setTimeout(() => {
          if (!element.parentElement.classList.contains('open')) {
            element.click()
          }
          this.unlockMenu('none')
          window.Vue.onboarding.driver.exec('#submenu-logins-seguradoras', {
            title:
              'O primeiro passo é configurar o login e senha das CIAs seguradoras.',
            description:
              'Clique em "Login Seguradoras" para que o Segfy possa fazer cotações, buscas e consultas para você.',
            position: 'right',
            showButtons: false
          })
        }, 200)
        window.scrollTo(0, 0)
        this.unlockMenu('none')
      } else if (val === 5) { 
        this.unlockMenu('all')
        setTimeout(() => {
          let element = document.getElementById('menu-propostas-e-apólices')
          if (!element.parentElement.classList.contains('open')) {
            element.click()
          }
          this.unlockMenu('none')
          window.Vue.onboarding.driver.exec('#submenu-busca-de-documentos', {
            title:
              'Agora o Segfy pode buscar documentos para você no portal das Seguradoras',
            description:
              'Buscamos uma vez por dia todos os documentos disponibilizados pelas seguradoras',
            position: 'right',
            showButtons: false
          })
        }, 150)
       } else if (val === 8) {
        this.unlockMenu('none')
        window.Vue.onboarding.driver.exec('#submenu-importar-pdf-', {
          title: 'Você pode também importar os documentos que já estão salvos no seu computador.',
          position: 'right',
          showButtons: false
        })
       } else if (val === 10) {
        this.unlockMenu('all')
        setTimeout(() => {
          this.unlockMenu('none')
          window.Vue.onboarding.driver.exec('#menu-multicálculo', {
            title: 'Acompanhar funil de vendas.',
            description: 'O próximo passo é utilizar o HFy e fazer sua primeira cotação pelo Segfy.',
            position: 'right',
            showButtons: false
          })
        }, 300)
      } else if (val === 13) {
        this.unlockMenu('none')
        window.Vue.onboarding.driver.exec('#menu-home', {
          title:
            'Por fim, clique em "Home" para ver a sua página inicial no Segfy.',
          position: 'right',
          showButtons: false
        })
     } else if (val === 16) {
        this.unlockMenu('all')
        setTimeout(() => {
          let element = document.getElementById('menu-ajuda')
          if (!element.parentElement.classList.contains('open')) {
            element.click()
          }
          this.unlockMenu('none')
          window.scrollTo(0, 0)
          window.Vue.onboarding.driver.exec(
            '#div-menu-ajuda',
            {
              title:
                'Por fim, basta consultar a Central de Ajuda e Solicitar Suporte sempre que tiver dúvidas.',
              description:
                'Possuímos diversos artigos explicativos, e nossa equipe está disposta a te atender.',
              position: 'right',
              showButtons: true,
              closeBtnText: 'OK, Entendi!'
            },
            false
          )
        }, 200)
      } else if (val === 17) {
        this.unlockMenu('all')
        this.dismissEveryFuckingBlockHighlighted('all')
      }
    },
    unlockMenu (condition) {
      document.getElementById('scrollDiv').style.pointerEvents = condition
      document.getElementById('navbarMenuTopoLayout').style.pointerEvents = condition
      if (condition === 'all') condition = 'text'
      document.getElementById('scrollDiv').style.userSelect = condition
      document.getElementById('navbarMenuTopoLayout').style.userSelect = condition
    },

    dismissEveryFuckingBlockHighlighted (condition) {
      document.getElementById(
        'submenu-logins-seguradoras'
      ).style.pointerEvents = condition
      document.getElementById(
        'submenu-busca-de-documentos'
      ).style.pointerEvents = condition
      document.getElementById(
        'submenu-importar-pdf-'
      ).style.pointerEvents = condition
      document.getElementById(
        'submenu-orçamentos'
      ).style.pointerEvents = condition
      document.getElementById('menu-home').style.pointerEvents = condition
      document.getElementById('div-menu-ajuda').style.pointerEvents = condition
      if (condition === 'all') condition = 'text'
      document.getElementById(
        'submenu-logins-seguradoras'
      ).style.userSelect = condition
      document.getElementById(
        'submenu-busca-de-documentos'
      ).style.userSelect = condition
      document.getElementById(
        'submenu-importar-pdf-'
      ).style.userSelect = condition
      document.getElementById(
        'submenu-orçamentos'
      ).style.userSelect = condition
      document.getElementById('menu-home').style.userSelect = condition
      document.getElementById('div-menu-ajuda').style.userSelect = condition
    },
    getDivider (menu) {
      if (!menu.destacado && this.divider === false) {
        menu.divider = true
      }
      menu.divider = false
    },
    isActive (rota, link, index, isGroup) {
      let path = this.currentPath
      let linkLower = link ? link.toLowerCase() : ''
      let active = false
      if (path === '/home' && index === 0) {
        active = true
      } else if (!isGroup) {
        active = path === (link ? linkLower : '')
      }

      if (active) {
        this.$nextTick(() => {
          let menus = document.getElementsByClassName(
            'sidenav-item group-item'
          )
          if (menus && menus.length > 0) {
            for (let i = 0; i < menus.length; i++) {
              menus[i].classList.remove('active')
              menus[i].classList.remove('open')
            }
          }
          setTimeout(() => {
            let parentGroup = document.getElementsByName(rota)
            if (parentGroup.length > 0) {
              parentGroup[0].classList.add('active')
              parentGroup[0].classList.add('open')
            }
          }, 100)
        })
      }

      return active
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },

    onGroupHoverEnter (event, elem) {
      if (!this.layoutHelpers.isCollapsed()) return
      if (!elem.subitems || elem.subitems.length === 0) return
      const rect = event.currentTarget.getBoundingClientRect()
      this.$root.$emit('sidenav-flyout-show', { elem, rect })
    },
    onGroupHoverLeave () {
      this.$root.$emit('sidenav-flyout-item-leave')
    },
    updateScrollbar () {
      if (this.$refs.scrollDiv && this.$refs.scrollDiv.update) {
        this.$refs.scrollDiv.update()
      }
    },
    onWindowFocusBadge () {
      this.refreshFinanceiroBadge()
    },
    // Pergunta ao app novo, para cada produto do menu que tem tela de apresentação, se o
    // usuário já a dispensou. Tem que estar resolvido ANTES do clique (ver onClick).
    consultarApresentacoes () {
      const links = []
      this.sideMenuItems.forEach((m) => {
        links.push(m.link)
        if (m.subitems) {
          m.subitems.forEach((s) => links.push(s.link))
        }
      })
      links
        .filter((link) => APRESENTACOES[link])
        .forEach((link) => {
          const chave = APRESENTACOES[link]
          consultarApresentacao(chave).then((exibir) => {
            this.$set(this.apresentacoesDispensadas, chave, !exibir)
          })
        })
    },
    // A LP (iframe do app novo) avisa quando o usuário marca "não exibir" e clica no CTA:
    // o próximo clique no menu já vai direto ao produto, sem esperar recarregar o menu.
    onMensagemApresentacao (evento) {
      if (ehDispensaDaApresentacao(evento)) {
        this.$set(this.apresentacoesDispensadas, evento.data.chaveModulo, true)
      }
    },
    deveMostrarApresentacao (link) {
      const chave = APRESENTACOES[link]
      return !!chave && !this.apresentacoesDispensadas[chave]
    },
    refreshFinanceiroBadge () {
      fetchMeusPagamentosBadge()
        .then((r) => {
          if (r.success && r.show) {
            this.financeiroBadge = { level: r.level, days: r.days }
          } else {
            this.financeiroBadge = null
          }
        })
        .catch(() => {
          this.financeiroBadge = null
        })
    },
    requestMenuItems (serverUrl) {
      if (this.sideMenuItems.length > 0 && !serverUrl) {
        return
      }

      getMenu()
        .then((resp) => {
          if (resp.success) {
            const newItems = resp.data
            if (
              JSON.stringify(this.sideMenuItems) !== JSON.stringify(newItems)
            ) {
              this.sideMenuItems = newItems
            }

            let foundTarefa = this.sideMenuItems.find(function (element) {
              return element.title === 'Tarefas'
            })
            if (foundTarefa) {
              getTarefas()
                .then((resp) => {
                  if (resp.success) {
                    this.qtdTarefas = resp.data
                  }
                })
                .catch(() => {})
            }
            const temFinanceiro = this.sideMenuItems.some(
              (m) =>
                (m.link || '').indexOf('/financeiro') === 0 ||
                m.title === 'Financeiro' ||
                (m.subitems && m.subitems.some((s) => (s.link || '').indexOf('/financeiro') === 0))
            )
            if (temFinanceiro) {
              this.refreshFinanceiroBadge()
            }
            // Consulta se o usuário já dispensou a apresentação de cada produto SaaS do menu
            // (card 86akr879k) — precisa estar pronta ANTES do clique, por isso roda aqui.
            this.consultarApresentacoes()
          } else {
            this.noMenuItems = true
          }
          this.menuLoading = false
        })
        .catch(() => {
          this.noMenuItems = true
          this.menuLoading = false
        })
    },
    onClick (menu) {
      this.consumirBadgeNovo(menu)
      if (
        menu.link === '/multicalculo/orcamento-multicalculo-saude-trindade' &&
        this.usuarioLiberadoCotarSaude === false
      ) {
        this.$refs.modalContratarMenu.openModal()
      } else {
        // Os produtos SaaS abrem em aba nova, para o corretor não perder o Gestão de
        // vista. O window.open precisa ficar AQUI, dentro do handler do clique: em
        // qualquer outro lugar (no abrir.vue, ou trocando o target="_top" do form do
        // launcher por _blank) seria abertura sem gesto do usuário, e o navegador
        // bloqueia como popup. Se ainda assim vier bloqueado, cai no fluxo antigo (a
        // rota com o iframe) em vez de não fazer nada.
        //
        // Com tela de apresentação ainda não dispensada (ou resposta ainda não chegou /
        // falhou), não abre aba: segue para a rota, que mostra a LP dentro do Gestão.
        const launcherSaas = LAUNCHERS_SAAS[menu.link]
        if (launcherSaas && !this.deveMostrarApresentacao(menu.link)) {
          const janela = window.open(`${process.env.VUE_APP_NEW_SERVER}${launcherSaas}`, '_blank')
          if (janela) {
            janela.focus()
            return
          }
        }

        if (menu.link.indexOf('http') >= 0) {
          let win = window.open(menu.link, '_blank')
          win.focus()
        } else {
          if (new Date() - this.ultimaChecagemRestricao <= 5 * 60000) {
            this.$router.push(this.setURL(menu.link))
          } else {
            getRestricaoHorarioAtiva().then((resp) => {
              this.ultimaChecagemRestricao = new Date()

              if (resp.success) {
                if (resp.data == null) {
                  logoffUser().then((o) => {
                    if (process.env.VUE_APP_FAYE !== 'local') {
                      window.Vue.hub.connectionFaye.pub(
                        'logoff',
                        window.Vue.hub.connectionFaye.uid
                      )
                    }

                    this.logoutLegado()

                    window.Vue.onboarding.driver.reset()

                    window.Vue.$store._actions['auth/forgetUser'][0]()
                    window.Vue.$noty.error(
                      'O seu usuário foi desconectado por conta da restrição do horário em seu cadastro.'
                    )
                    window.open(
                      `${process.env.VUE_APP_SSO_FRONT}/login?callback=${process.env.VUE_APP_SERVER}`,
                      '_self'
                    )
                  })
                } else {
                  this.$router.push(this.setURL(menu.link))
                }
              }
            })
          }
        }
      }
    },
    onParentMenuClick (event) {
      event.preventDefault()
      event.stopPropagation()

      let menu = event.currentTarget
      menu.parentElement.classList.toggle('open')

      this.updateScrollbar()

      setTimeout(() => {
        let openedMenus = document.getElementsByClassName(
          'sidenav-item group-item open'
        )
        if (openedMenus && openedMenus.length > 0) {
          if (menu.parentElement.classList.contains('open') >= 0) {
            var link = menu.parentElement.querySelectorAll('.sidenav-link')[1]
            this.scrollToElement(
              link,
              this.$refs.scrollDiv.$el.querySelector('.sidenav-inner'),
              500,
              100
            )
          }
        } else {
          this.scrollTop(
            0,
            500,
            this.$refs.scrollDiv.$el.querySelector('.sidenav-inner')
          )
        }
      }, 200)
      let menus = document.getElementsByClassName(
        'sidenav-item group-item open'
      )
      if (menus && menus.length > 0) {
        for (let i = 0; i < menus.length; i++) {
          if (menus[i] !== menu.parentElement) {
            menus[i].classList.remove('open')
          }
        }
      }
    },
    handleLogout () {
      logoffUser()
        .then((resp) => {
          if (process.env.VUE_APP_FAYE !== 'local') {
            window.Vue.hub.connectionFaye.pub(
              'logoff',
              window.Vue.hub.connectionFaye.uid
            )
          }
          this.logoutLegado()
          this.forgetUser()
          window.Vue.onboarding.driver.reset()
          Cookies.set('vuex', 'true', {
            expires: -1,
            domain: `${process.env.VUE_APP_COOKIE_DOMAIN}`
          })
          window.location.href = `${process.env.VUE_APP_SSO_FRONT}/logout?callback=${process.env.VUE_APP_SERVER}`
        })
        .catch()
    },
    // A loja de add-ons (iframe do Meus Pagamentos) avisa quando os módulos mudaram:
    // recarrega o menu para o item do módulo aparecer sem recarregar a página.
    onMensagemLoja (evento) {
      if (ehAvisoDeModulosAlterados(evento)) {
        this.recarregarMenu()
      }
    },
    // Debounce: contratar/trocar plano pode gerar avisos seguidos.
    recarregarMenu () {
      clearTimeout(this.recargaMenuTimer)
      this.recargaMenuTimer = setTimeout(() => {
        this.recargaMenuTimer = null
        try { sessionStorage.removeItem(this.chaveCacheDoMenu()) } catch (e) { }
        this.requestMenuItems(true)
      }, 500)
    },
    // Mesma chave do cache do menu na sessão (requestMenuItems). Onde o cache não existe,
    // mexer nela não faz nada.
    chaveCacheDoMenu () {
      return 'segfy:menu:v1:' + this.$store.state.auth.usuarioId
    },
    // Primeiro clique no módulo novo: some a badge na hora e avisa a auth em segundo plano.
    // Nada aqui é aguardado nem pode lançar: o window.open do onClick só passa pelo
    // bloqueador de popup se rodar de forma síncrona dentro do clique.
    consumirBadgeNovo (menu) {
      try {
        const modulo = this.moduloNovoDoClique(menu)
        if (!modulo) return
        this.$set(modulo, 'isNew', false)
        this.marcarVistoNoCacheDoMenu(modulo.chaveModulo)
        marcarModuloVisto(modulo.chaveModulo).catch(() => {})
      } catch (e) { }
    },
    // O item clicado, ou o grupo do menu raiz dono dele: o cabeçalho do grupo só abre o
    // submenu (não passa pelo onClick), então o clique que conta é o do subitem.
    moduloNovoDoClique (menu) {
      const ehModuloNovo = (item) => !!item && item.isNew && !!item.chaveModulo
      if (ehModuloNovo(menu)) return menu
      const grupo = this.sideMenuItems.find((item) => item.subitems && item.subitems.indexOf(menu) >= 0)
      return ehModuloNovo(grupo) ? grupo : null
    },
    marcarVistoNoCacheDoMenu (chave) {
      try {
        const chaveCache = this.chaveCacheDoMenu()
        const cache = JSON.parse(sessionStorage.getItem(chaveCache) || 'null')
        if (!cache || !Array.isArray(cache.items)) return
        cache.items.forEach((item) => {
          if (item.chaveModulo === chave) item.isNew = false
        })
        sessionStorage.setItem(chaveCache, JSON.stringify(cache))
      } catch (e) { }
    },
    ...mapActions({
      forgetUser: 'auth/forgetUser'
    })
  }
}
</script>
